import { Dispatch } from 'redux'
import NotificationInterface from '../../interfaces/client/Notification'

import {
  removeNotification,
  addNotification,
} from '../../actions/notifications'

import { buildParentDateOfBirthError } from '../../utils/notifications'

export default (
  targetElement: HTMLInputElement,
  passengerId: string,
  validator: Function,
  dispatch: Dispatch,
  dateOfBirthError?: NotificationInterface
) => {
  const { value } = targetElement

  const inputValueMatchesThePattern = targetElement.checkValidity()

  if (!inputValueMatchesThePattern && !dateOfBirthError) return

  const isValidDateOfBirth = validator(value)

  if (!isValidDateOfBirth && !dateOfBirthError && value !== '') {
    const customErrorNotification = buildParentDateOfBirthError(passengerId)

    dispatch(addNotification(customErrorNotification))
    return
  }

  if (
    (isValidDateOfBirth && dateOfBirthError) ||
    (dateOfBirthError && value === '')
  ) {
    dispatch(removeNotification(dateOfBirthError.id))
  }
}
